import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmReviewClickedPayload {
  candidateId?: string;
}

/**
 * Fires when the user clicks "Review" on the "review additional applications" popup.
 * Event: dental_portal:bulk_confirm:review_clicked
 */
export function fireBulkConfirmReviewClicked(
  payload: IBulkConfirmReviewClickedPayload = {},
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:review_clicked', {
    candidate_id: payload.candidateId,
  });
}
